interface Props {
  activeColor: string;
}

const UrgencyIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="urgencyGradient"
          x1="24"
          y1="20"
          x2="104"
          y2="108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B5CF6" />
          <stop offset="0.5" stopColor="#06B6D4" />
          <stop offset="1" stopColor="#FACC15" />
        </linearGradient>

        <linearGradient
          id="boltGradient"
          x1="52"
          y1="34"
          x2="78"
          y2="91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#22D3EE" />
          <stop offset="1" stopColor="#FACC15" />
        </linearGradient>

        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <rect x="12" y="12" width="104" height="104" rx="28" fill="#0B1220" />
      <rect
        x="12"
        y="12"
        width="104"
        height="104"
        rx="28"
        stroke="url(#urgencyGradient)"
        strokeWidth="2"
        opacity="0.5"
      />

      <circle
        cx="64"
        cy="64"
        r="38"
        stroke="url(#urgencyGradient)"
        strokeWidth="2"
        opacity="0.18"
      />
      <circle
        cx="64"
        cy="64"
        r="28"
        stroke="url(#urgencyGradient)"
        strokeWidth="1.5"
        opacity="0.14"
      />

      <path
        d="M69 30L44 67H60L55 98L84 56H67L69 30Z"
        stroke="url(#boltGradient)"
        strokeWidth="4"
        strokeLinejoin="round"
        filter="url(#glow)"
      />

      <circle cx="42" cy="46" r="4" fill="#A78BFA" />
      <circle cx="87" cy="42" r="4" fill="#22D3EE" />
      <circle cx="91" cy="78" r="4" fill="#FACC15" />
      <circle cx="38" cy="84" r="4" fill="#67E8F9" />

      <path
        d="M46 47L54 51"
        stroke="#A78BFA"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M83 45L75 50"
        stroke="#22D3EE"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M86 76L77 72"
        stroke="#FACC15"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M42 82L50 76"
        stroke="#67E8F9"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default UrgencyIcon;
